import { AppState as State } from '@ducks/index';

/**
 * @summary リフレッシュを行うためのstateを返却する
 * @param {State} state
 * @returns {Record<string, never>}
 */
export const getRefreshId = (state: State) => state.customProperty.refresh;

/**
 * @summary ローディング状態かを返却する
 * @param {State} state
 * @returns {boolean} ローディング状態か
 */
export const checkIsLoading = (state: State) => state.customProperty.isLoading;

/**
 * @summary 送信処理中かを返却する
 * @param {State} state
 * @returns {boolean} 送信処理中か
 */
export const checkIsSubmitting = (state: State) => state.customProperty.isSubmitting;

/**
 * @summary 機能毎のカスタムプロパティの項目定義リストを返却する
 * @param {State} state
 * @returns {CustomPropertyLayout[]} 機能毎のカスタムプロパティの項目定義リスト
 */
export const getCustomPropertyLayoutList = (state: State) =>
  state.customProperty.customPropertyLayoutList;

/**
 * @summary カスタムプロパティの設定情報を返却する
 * @param {State} state
 * @returns {CustomPropertyLayoutSetting[]} カスタムプロパティの設定情報
 */
export const getCustomPropertyLayoutSettingList = (state: State) =>
  state.customProperty.customPropertyLayoutSettingList;
